module.exports = __webpack_public_path__ + "img/2023big2.a06530aa.png";